import * as React from 'react';
import styled, {css} from 'styled-components'
import {ConstBreakPoint, ConstWidth, ConstZIndex} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    isOpen: boolean;
}

const MenuWrapperDefault: React.FC<IProps> = (props) => {

    const {isOpen, ...DivProps} = props;

    return (
        <div {...DivProps}/>
    );
};

const MenuWrapper = styled(MenuWrapperDefault)`
    height: 100%;
    position: fixed;
    left: -${ConstWidth.MenuWidth}; /*メニュー横幅 width と合わせる*/
    top: 0;
    transition: transform 0.3s ease 0s; /*0.3s はアニメーションにかかる時間*/
    z-index: ${ConstZIndex.hamburgerMenu};
    ${props => props.isOpen && css`
        transform: translate(${ConstWidth.MenuWidth}); /*メニュー横幅 width と合わせる*/
    `}
    @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
        display: block;
        position: static;
        height: auto;
        z-index: ${ConstZIndex.menu};
        transform: translate(0); /*pc画面時は固定させるため*/
    }
`;

export default MenuWrapper;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/menu_wrapper.tsx